/**
 * Password field validation
 * @module validate-password
 * @author Vincent Falconi <vfalconi@sumologic.com>
 */


/**
 * Validation policies
 */
const policies = [
	/** @type {object} */
	{
		name: 'length',
		min: 8,
		max: 100,
	},
	/** @type {object} */
	{
		name: 'lowercase',
		pattern: /[a-z]/g,
	},
	/** @type {object} */
	{
		name: 'uppercase',
		pattern: /[A-Z]/g,
	},
	/** @type {object} */
	{
		name: 'number',
		pattern: /\d/g,
	},
	/** @type {object} */
	{
		name: 'specialChar',
		pattern: /[\^\+\.\=\!\-\_\*\|\,\"\<\>\[\]\{\}\`\'\;\(\)\@\&\$\#\%]/g,
	},
];



/**
 * Test regex pattern policies
 * @param {string} str
 * @param {regex} pattern
 */
const testRegexPolicy = (str, pattern) => {
	return str.match(pattern) !== null;
}



/**
 * Test min/max policies
 * @param {string} str
 * @param {int} min
 * @param {int} max
 */
const testMinMaxPolicy = (str, min, max) => {
	return (str.length >= min && str.length <= max)
}



/**
 * Where the validation magic happens.
 * @param {string} str
 * @returns {map} A Map of validation policies and their results
 */
const runValidation = (str) => {
	const results = policies.map(policy => {
		let policyResult;

		if (policy.name === 'length') {
			policyResult = testMinMaxPolicy(str, policy.min, policy.max);
		} else {
			policyResult = testRegexPolicy(str, policy.pattern);
		}

		return [policy.name, policyResult];
	});

	return new Map(results);
}



/**
 * @param {string} strPassword
 */
export default (strPassword) => {
	return runValidation(strPassword);
}
